import React, { useContext } from 'react';
import { ServerConfigContext } from '../context/ServerConfigContext';
import './SettingsPage.css';

const SettingsPage = () => {
  const { servers } = useContext(ServerConfigContext);

  return (
    <div className="page-container">
      <div className="settings-container">
        <div className="settings-header">
          <h2>서버 설정</h2>
          <p>서버 설정은 소스 코드에 하드코딩되어 있으며 수정할 수 없습니다.</p>
        </div>

        <div className="servers-section">
          <div className="section-header">
            <h3>등록된 서버 목록 (읽기 전용)</h3>
          </div>

          <div className="servers-list">
            {servers.map(server => (
              <div key={server.id} className={`server-card ${server.isActive ? 'active' : ''}`}>
                <div className="server-header">
                  <div className="server-info">
                    <h4>{server.name}</h4>
                    <span className="server-url">{server.baseUrl}</span>
                  </div>
                  <div className="server-actions">
                    <span className={`status-badge ${server.isActive ? 'active' : 'inactive'}`}>
                      {server.isActive ? '활성' : '비활성'}
                    </span>
                  </div>
                </div>
                <div className="server-details">
                  <span>도메인: {server.domain}</span>
                  <span>타임아웃: {server.apiTimeout}ms</span>
                  <span>ID: {server.id}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="info-box">
          <h4>📌 안내</h4>
          <p>
            서버 설정은 <code>src/context/ServerConfigContext.js</code> 파일에서 관리됩니다.<br/>
            개발 환경: <code>src/setupProxy.js</code>에서 프록시 설정<br/>
            프로덕션 환경: nginx에서 프록시 설정
          </p>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
